<template lang="pug">
.recharge-card
  .header
    .title {{ stepTitle }}
    .back-btn(@click='handleBack') 
      span.arrow ‹
      span {{ backBtnText }}
  .content
    .step-1(v-if='step === 1')
      .tips
        p 请输入您的充值卡卡密进行登录。
        p.sub-tip (线上购买的VIP服务无需使用卡密)
      .input-wrapper
        km-input(
          v-model='cardPassword',
          placeholder='请输入充值卡卡密',
          @enter='handleVerify'
        )
          i.icon.icon_card(slot='icon')
      .error-tip(v-if='errorText')
        .error-icon
          svg(width='20', height='20', viewBox='0 0 24 24')
            path(d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z', fill='#ff9800')
        .error-content
          .error-title 卡密未绑定
          .error-desc {{ errorText }}
          .error-action(v-if='showBindBtn', @click='handleBindNow') 立即绑定
      button.next-btn(@click='handleVerify') 下一步

    .step-2(v-if='step === 2')
      .tips-box
        .tips-label
          span.valid-tag 卡密有效
          span.type-tag 正式卡
        .tips-text 请选择将此充值卡绑定到哪个账号：
      .card-info-box
        .card-left
          .card-name 驰声听说在线充值卡
          .card-tags
            span.region-tag {{ cardInfo.cityName }}
        .card-right
          .validity-value {{ cardInfo.vipMonth }}月
          .validity-label 有效期
      .options
        .option-card(@click='handleRegisterNew')
          .option-icon.green
            svg(width='24', height='24', viewBox='0 0 24 24')
              path(d='M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z', fill='#fff')
          .option-text
            .option-title 注册新账号
            .option-desc 绑定到新手机号
          .arrow-icon ›
        .option-card(@click='handleBindExisting')
          .option-icon.blue
            svg(width='24', height='24', viewBox='0 0 24 24')
              path(d='M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z', fill='#fff')
          .option-text
            .option-title 绑定已有账号
            .option-desc 绑定到现有手机号
          .arrow-icon ›
      .back-link(@click='handleBackStep1') 返回上一步

    .step-3(v-if='step === 3')
      .tips-box.blue
        .tips-text 请输入您现有的学校账号或手机号，以完成充值卡绑定。
      .form
        .form-item
          km-input(
            v-model='bindUsername',
            placeholder='学校发放账号/手机号',
            @enter='handleBindNext'
          )
            i.icon.icon_username(slot='icon')
        .form-item
          km-input(
            v-model='bindPassword',
            type='password',
            placeholder='请输入密码',
            @enter='handleBindNext'
          )
            i.icon.icon_password(slot='icon')
      .forgot-pwd(@click='handleForgotPassword') 忘记密码?
      .error-tip-inline(v-if='bindErrorText')
        svg(width='16', height='16', viewBox='0 0 24 24')
          path(d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z', fill='#ff9800')
        span {{ bindErrorText }}
      button.next-btn(@click='handleBindNext', :disabled='bindLoading') {{ bindLoading ? '验证中...' : '下一步' }}

    .step-4(v-if='step === 4')
      .card-info
        .card-main
          .card-left
            .card-header
              .card-name 驰声听说在线充值卡
              .tag 正式卡
            .card-desc 英语听说提分必备
          .card-right
            .card-validity
              .validity-value {{ previewData.vipMonth }}月
              .validity-label 有效期
            .card-region {{ previewData.cityName }}
      .bind-info
        .info-item
          .label 绑定账号
          .value {{ previewData.params && previewData.params.username }}
        .info-item(style='margin-top: 6px')
          .label 绑定后有效期至
          .value.expiry {{ formattedExpiryDate }}
      //- .warning
      //-   svg(width='16', height='16', viewBox='0 0 24 24')
      //-     path(d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z', fill='#ff9800')
      //-   span 下次登录 app 可直接用手机号和密码登录
      button.confirm-btn(@click='handleConfirmBind', :disabled='bindLoading')
        svg.check-icon(width='20', height='20', viewBox='0 0 24 24')
          path(d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z', fill='#fff')
        span {{ bindLoading ? '绑定中...' : '确定绑定' }}
</template>

<script>
import { verifyCard, bindCardPreview, bindCardToAccount } from '@/api'
import cryptoJs from 'crypto-js'

export default {
  name: 'RechargeCard',
  props: {
    onBack: {
      type: Function,
      default: function () { }
    }
  },
  data: function () {
    return {
      step: 1,
      cardPassword: '',
      cardInfo: null,
      errorText: '',
      showBindBtn: false,
      bindUsername: '',
      bindPassword: '',
      bindErrorText: '',
      bindLoading: false,
      previewData: null
    }
  },
  computed: {
    stepTitle: function () {
      var titles = {
        1: '充值卡登录',
        2: '充值卡登录',
        3: '绑定已有账号',
        4: '确认绑定'
      }
      return titles[this.step]
    },
    backBtnText: function() {
      var texts = {
        1: '返回登录',
        2: '返回登录',
        3: '返回选择',
        4: '返回修改'
      }
      return texts[this.step]
    },
    formattedExpiryDate: function() {
      if (!this.previewData || !this.previewData.vipExpiredDate) return ''
      var date = this.previewData.vipExpiredDate
      if (date.indexOf(' ') > -1) {
        date = date.split(' ')[0]
      }
      return date
    }
  },
  methods: {
    handleBack: function () {
      if (this.step === 1 || this.step === 2) {
        this.onBack()
      } else {
        this.step--
      }
      this.errorText = ''
      this.bindErrorText = ''
    },
    handleBackStep1: function () {
      this.step = 1
    },
    handleVerify: function () {
      var self = this
      var cardPassword = this.cardPassword.trim()

      if (!cardPassword) {
        this.errorText = '请输入卡密'
        this.showBindBtn = false
        return
      }

      this.errorText = ''

      verifyCard({ cardPassword: cardPassword }).then(function (res) {
        if (res.status === 1) {
          if (res.data.hasBind === false) {
            self.cardInfo = res.data
            self.errorText = '该卡密尚未绑定账号，请先绑定。'
            self.showBindBtn = true
          } else {
            self.$emit('loginSuccess', {
              username: res.data.username,
              password: res.data.password
            })
          }
        } else {
          self.errorText = res.info || '卡密无效'
          self.showBindBtn = false
        }
      }).catch(function () {
        self.errorText = '网络连接不稳定，请稍后再试'
        self.showBindBtn = false
      })
    },
    handleBindNow: function () {
      this.step = 2
    },
    handleRegisterNew: function () {
      this.$message.info('电脑端暂不支持新账号注册，请下载「听说在线学生APP」注册')
    },
    handleBindExisting: function () {
      this.step = 3
    },
    handleBindNext: function () {
      var self = this
      var username = this.bindUsername.trim()
      var password = this.bindPassword.trim()

      if (!username) {
        this.bindErrorText = '请输入学校发放账号或手机号'
        return
      }

      if (!password) {
        this.bindErrorText = '请输入密码'
        return
      }

      this.bindErrorText = ''
      this.bindLoading = true

      bindCardPreview({
        cardPassword: this.cardPassword,
        username: username,
        password: cryptoJs.MD5(password).toString()
      }).then(function (res) {
        if (res.status === 1) {
          self.previewData = res.data
          self.step = 4
        } else {
          self.bindErrorText = res.info || '账号或密码错误'
        }
      }).catch(function () {
        self.bindErrorText = '网络连接不稳定，请稍后再试'
      }).finally(function () {
        self.bindLoading = false
      })
    },
    handleConfirmBind: function () {
      var self = this
      if (!this.previewData || !this.previewData.params) return

      this.bindLoading = true

      bindCardToAccount({
        cardPassword: this.previewData.params.cardPassword,
        username: this.previewData.params.username,
        password: this.previewData.params.password
      }).then(function (res) {
        if (res.status === 1) {
          self.$message.success('绑定成功')
          self.$emit('bindComplete', {
            username: self.previewData.params.username,
            password: self.previewData.params.password
          })
        } else {
          self.$message.error(res.info || '绑定失败，请重试')
        }
      }).catch(function () {
        self.$message.error('网络连接不稳定，请稍后再试')
      }).finally(function () {
        self.bindLoading = false
      })
    },
    handleForgotPassword: function () {
      this.$emit('forgotPassword')
    }
  }
}
</script>

<style lang="less" scoped>
.recharge-card {
  padding: 30px 30px 0;
  width: 100% !important;
  margin: 0 auto;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 10px;
}

.title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

.back-btn {
  font-size: 14px;
  color: #666;
  cursor: pointer;
  padding: 6px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  background: #fff;
  transition: all 0.3s;
  display: flex;
  align-items: center;

  .arrow {
    margin-right: 4px;
    font-size: 16px;
  }

  &:hover {
    background: #f5f5f5;
    color: #333;
  }
}

.step-1, .step-2, .step-3, .step-4 {
  width: 100%;
}

.step-2 {
  padding-bottom: 10px;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tips {
  font-size: 14px;
  color: #333;
  text-align: left;
  margin-bottom: 20px;

  p {
    margin: 4px 0;
  }

  .sub-tip {
    font-size: 12px;
    color: #999;
  }
}

.input-wrapper {
  width: 100%;
  margin-bottom: 16px;
}

.error-tip {
  background: #fff3e0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
}

.error-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

.error-content {
  flex: 1;
}

.error-title {
  font-size: 14px;
  font-weight: bold;
  color: #ff9800;
  margin-bottom: 4px;
}

.error-desc {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
}

.error-action {
  display: inline-block;
  background: #ff9800;
  color: #fff;
  padding: 6px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: #f57c00;
  }
}

.next-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #24cc7c;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  text-align: center;

  // &:hover:not(:disabled) {
  //   background: #24cc7c;
  // }

  &:active:not(:disabled) {
    transform: scale(0.98);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
}

.tips-box {
  background: #e0e7ff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  width: 100%;
  box-sizing: border-box;

  &.blue {
    background: #e3f2fd;
  }
}

.tips-label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.valid-tag {
  font-size: 14px;
  font-weight: bold;
  color: #1e3a8a;
}

.type-tag {
  font-size: 12px;
  color: #3b82f6;
}

.tips-text {
  font-size: 14px;
  color: #333;
}

.card-info-box {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 16px;
  margin-bottom: 16px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-left {
  .card-name {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .card-tags {
    display: flex;
    gap: 8px;
  }

  .region-tag {
    font-size: 12px;
    color: #9ca3af;
  }
}

.card-right {
  text-align: right;

  .validity-value {
    font-size: 18px;
    font-weight: bold;
    color: #10b981;
  }

  .validity-label {
    font-size: 12px;
  }
}

.options {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
  width: 100%;
}

.option-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: #f0f7ff;
    border-color: #3b82f6;
  }
}

.option-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &.green {
    background: #10b981;
  }

  &.blue {
    background: #3b82f6;
  }
}

.option-text {
  flex: 1;
}

.option-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 4px;
}

.option-desc {
  font-size: 12px;
  color: #9ca3af;
}

.arrow-icon {
  color: #9ca3af;
  font-size: 20px;
}

.back-link {
  font-size: 14px;
  color: #6b7280;
  cursor: pointer;
  text-align: center;
  margin-top: 8px;

  &:hover {
    color: #333;
  }
}

.form {
  width: 100%;
  margin-bottom: 8px;
}

.form-item {
  width: 100%;
  margin-bottom: 12px;
}

.forgot-pwd {
  align-self: flex-end;
  font-size: 14px;
  color: #999;
  margin-bottom: 16px;
  cursor: pointer;

  &:hover {
    color: #3b82f6;
  }
}

.error-tip-inline {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff3e0;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
  width: 100%;
  box-sizing: border-box;
  font-size: 14px;
  color: #ff9800;
}

.card-info {
  background: linear-gradient(135deg, #5da4f8 0%, #3b82d6 100%);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  color: #fff;
  width: 100%;
  box-sizing: border-box;
  * {
    color:#fff;
  }
}

.card-main {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.card-left {
  flex: 1;
}

.card-header {
  margin-bottom: 8px;
}

.card-name {
  font-size: 16px;
  font-weight: bold;
}

.tag {
  display: inline-block;
  background: #ffd700;
  color: #333;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.card-desc {
  font-size: 14px;
  opacity: 0.9;
}

.card-right {
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.card-region {
  font-size: 12px;
  background: transparent;
  padding: 4px 12px;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  margin-top: 10px;
}

.card-validity {
  text-align: right;

  .validity-label {
    font-size: 12px;
    opacity: 0.8;
  }

  .validity-value {
    font-size: 18px;
    font-weight: bold;
  }
}

.bind-info {
  background: #eee;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  width: 100%;
  box-sizing: border-box;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .label {
    font-size: 14px;
    color: #666;
  }

  .value {
    font-size: 16px;
    color: #333;
    font-weight: bold;

    &.expiry {
      color: #10b981;
    }
  }
}

.warning {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff3e0;
  color: #ff9800;
  font-size: 14px;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  width: 100%;
  box-sizing: border-box;
}

.confirm-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #24cc7c;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  * {
    color: #fff;
  }

  .check-icon {
    flex-shrink: 0;
  }

  // &:hover:not(:disabled) {
  //   background: #219653;
  // }

  &:active:not(:disabled) {
    transform: scale(0.98);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/components/RechargeCard.vue